"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorPanel = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ROICalculatorPanelContents_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorPanelContents/ROICalculatorPanelContents");
var ROIVariableKeyUtils_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROIVariableKey/ROIVariableKeyUtils");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ROICalculatorWidget_1 = require("../ROICalculatorWidget");
var ROITextArea_1 = require("../ROITextArea");
var ROIVariableInput_1 = require("./ROIVariableInput");
var ROICalculatorPanel = (function (_super) {
    __extends(ROICalculatorPanel, _super);
    function ROICalculatorPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleValueChange = function (id, key, value) {
            _this.props.onVariableInputChange(id, key, value);
        };
        _this.handleOptionEdit = function (id, value) {
            _this.props.onEditOption(ROICalculatorWidget_1.ROIElement.VariableInput, id, value);
        };
        return _this;
    }
    Object.defineProperty(ROICalculatorPanel.prototype, "addVariableDisabled", {
        get: function () {
            return this.props.variableCounter >= ROIVariableKeyUtils_1.MAX_VARIABLE_INPUT_KEY;
        },
        enumerable: false,
        configurable: true
    });
    ROICalculatorPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, inputs = _a.inputs, title = _a.title, onTitleChange = _a.onTitleChange, description = _a.description, onDescriptionChange = _a.onDescriptionChange, onRemoveVariableInput = _a.onRemoveVariableInput, onAddVariableInput = _a.onAddVariableInput, widgetId = _a.widgetId, roiStepsOrchestrator = _a.roiStepsOrchestrator;
        var inputIds = Object.keys(inputs);
        return (react_1.default.createElement(ROICalculatorPanelContents_1.ROICalculatorPanelContents, { widgetId: widgetId, title: react_1.default.createElement("div", { className: "user-font" },
                react_1.default.createElement(ROITextArea_1.ROITextArea, { label: "ROI calculator title input", className: "roi-title__textarea", placeholder: "Title", onChange: onTitleChange, value: title })), description: react_1.default.createElement("div", { className: "user-font" },
                react_1.default.createElement(ROITextArea_1.ROITextArea, { label: "ROI calculator description input", className: "roi-description__textarea", placeholder: "Description", onChange: onDescriptionChange, value: description })), inputs: react_1.default.createElement("div", { className: "roi-calculator-panel-contents__variable-input-list" },
                inputIds.map(function (id, index) { return (react_1.default.createElement(ROIVariableInput_1.ROIVariableInput, { id: id, key: id, label: inputs[id].label, value: inputs[id].value, prefix: inputs[id].prefix, suffix: inputs[id].suffix, min: inputs[id].min, max: inputs[id].max, onChange: function (key, value) { return _this.handleValueChange(id, key, value); }, onDelete: function () { return onRemoveVariableInput(id); }, onOptionEdit: _this.handleOptionEdit, trackValueChange: function () { return _this.props.trackVariableInputValueChange(id); }, index: index, roiStepsOrchestrator: roiStepsOrchestrator })); }),
                react_1.default.createElement("div", { className: "add-variable__wrapper" },
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, disabled: this.addVariableDisabled, onClick: onAddVariableInput, width: "full" },
                        react_1.default.createElement("div", { className: "add-variable__inner" },
                            react_1.default.createElement(icons_1.Add, null),
                            this.addVariableDisabled ? "Cannot add new variable (out of keyspace)" : "Add variable")))) }));
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorPanel.prototype, "addVariableDisabled", null);
    ROICalculatorPanel = __decorate([
        mobx_react_1.observer
    ], ROICalculatorPanel);
    return ROICalculatorPanel;
}(react_1.default.Component));
exports.ROICalculatorPanel = ROICalculatorPanel;
